const headings = {
    title: '',
    description: '',
    breadcrumbs: [],
    actions: [],
    toBack: {
        label: '',
        route: {}
    },
    
};

const appInfo = {
    id: null,
    isRejected: false,
    status: '',
    officeId: null,
    comment: '',
    office: '',
    date: ''
};

const headingsModule = {
    namespaced: true,
    state: {
        appInfo: appInfo,
        headings: headings,
        filterOptions: [],
        filter: 'YEAR',
    },
    getters: {
        getHeadings: state => state.headings,
        getAppInfo: state => state.appInfo,
        getBreadcrumbs: state => state.headings.breadcrumbs,
        getTitle: state => state.headings.title,
        getActions: state => state.headings.actions,
        getFilterOptions: state => state.filterOptions,
        getFilter: state => state.filter
    },
    mutations: {
        SET_HEADINGS: ( state, headings ) => {
            state.headings = headings;
        },
        SET_APPINFO: ( state, info ) => {
            state.appInfo = info;
        },
        SET_FILTER_OPTIONS: ( state, value ) => {
            state.filterOptions = value;
        },
        SET_FILTER: ( state, value ) => {
            state.filter = value;
        }
    },
    actions: {
        setHeadings: ( { commit }, value ) => commit( 'SET_HEADINGS', { ...headings, ...value } ),
        flushHeadings: ( { commit } ) => commit( 'SET_HEADINGS', headings ),
        setFilterOptions: ( { commit }, value ) => commit( 'SET_FILTER_OPTIONS', value ),
        setFilter: ( { commit }, value ) => commit( 'SET_FILTER', value ),
        setAppInfo: ( { commit }, value ) => commit( 'SET_APPINFO', value ),
        resetAppInfo: ( { commit } ) => commit( 'SET_APPINFO', appInfo )
    },
};

export default headingsModule;
